import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chakra-ui/react'
import Select from 'react-select'
import TextFactory from '../TextFactory/TextFactory'
import { text } from '../../utils/theme/components/text'
import { colors } from '../../utils/theme/styles'
const placeholderStyles = (provided) => ({
  ...provided,
  ...text.variants.body2,
  color: colors.gray[700],
})
const optionStyles = (provided, state) => {
  return {
    ...provided,
    ...text.variants.body1,
    color: state.isSelected ? colors.gray[50] : colors.gray[800],
  }
}

const singleValueStyles = (provided, state) => {
  return {
    ...optionStyles(provided, state),
    opacity: state.isDisabled ? 0.7 : null,
    color: state.isSelected ? colors.gray[50] : colors.gray[800],
  }
}
const selectorStyles = {
  option: optionStyles,
  placeholder: placeholderStyles,
  singleValue: singleValueStyles,
}
export default function SelectorUI({
  title,
  titleType,
  placeholder,
  selectorProps,
  boxShadow,
  disabled,
  border = null,
}) {
  return (
    <Box w="100%" h="100%">
      {title && <TextFactory title={title} titleType={titleType} />}
      <Select
        {...selectorProps}
        placeholder={placeholder}
        isDisabled={disabled}
        styles={{
          ...selectorStyles,
          control: (provided, state) => ({
            ...provided,
            boxShadow,
            border,
            backgroundColor: 'white',
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            '&:hover': {
              border,
            },
            '&:focus': {
              border,
            },
          }),
          container: (provided, state) => ({
            ...provided,
            cursor: state.isDisabled ? 'not-allowed' : 'pointer',
            pointerEvents: 'all',
          }),
        }}
      />
    </Box>
  )
}

SelectorUI.propTypes = {
  boxShadow: PropTypes.string,
  border: PropTypes.string,
  placeholder: PropTypes.string,
  selectorProps: PropTypes.shape({
    isClearable: PropTypes.bool,
    isSearchable: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
    value: PropTypes.object,
  }),
  title: PropTypes.string,
  titleType: PropTypes.string,
  disabled: PropTypes.bool,
}
